/* eslint-disable prettier/prettier */
import axios from 'http.service';
import apiErrorMsg from 'Common/Utils/apiErrorMsg';

const baseUrl = '/api/v2/appointee';

export const getContractsByAppointeeId = async (appointeeId, errorCb) => {
    const {
		status,
		data: { data, errors }
    } = await axios.get(baseUrl + '/' + appointeeId + '/contracts');
    if (status === 200) {
		return data;
    }
	const errorMessage = apiErrorMsg(status, errors);
	return errorCb(errorMessage);
};
export const downloadContractPdfForAppointmentId = async (appointmentId, year, appointmentType, errorCb) => {
    const {
        status,
        data: { data }
    } = await axios.get(baseUrl + '/contractpdf/' + appointmentId + '/' + year + '/' + appointmentType);
    if (status === 200) {
        return data;
    }
    const errorMessage = apiErrorMsg(status);
    return errorCb(errorMessage);
};
